"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpectrumContext = exports.RootSpectrumPreferenceUpdaterContext = exports.RootSpectrumPreferenceContext = exports.RootSpectrumContext = exports.DEFAULT_SPECTRUM = void 0;
var _react = require("react");
var _cdsUtils = require("@cbhq/cds-utils");
const DEFAULT_SPECTRUM = 'light';
exports.DEFAULT_SPECTRUM = DEFAULT_SPECTRUM;
const SpectrumContext = /*#__PURE__*/(0, _react.createContext)(DEFAULT_SPECTRUM);
exports.SpectrumContext = SpectrumContext;
const RootSpectrumContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.RootSpectrumContext = RootSpectrumContext;
const RootSpectrumPreferenceContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.RootSpectrumPreferenceContext = RootSpectrumPreferenceContext;
const RootSpectrumPreferenceUpdaterContext = /*#__PURE__*/(0, _react.createContext)(_cdsUtils.noop);
exports.RootSpectrumPreferenceUpdaterContext = RootSpectrumPreferenceUpdaterContext;